import router from '@/router'
import {login} from "@/api/login/auth"
import {
    getToken,
    removeToken,
    setToken,
    getTimeEnd,
    setTimeEnd,
    removeTimeEnd,
    getEntCnpj, removeEntCnpj, setEntCnpj
} from "@/api/config/token";
import {usuarioRenovaToken} from "@/api/pessoa/usuario";
import {simplesNacionalAtualizaOptante} from "@/api/simples_nacional/optante";

export const state = {
    token: getToken(),
    entCNPJ: getEntCnpj(),
    tokenTimeEnd: getTimeEnd(),
    currentEntidade: getState('auth.currentEntidade'),
    currentUser: getState('auth.currentUser'),
    currenEmpresa: getState('auth.currentEmpresa'),
    empresasLiberadas: getState('auth.empresasLiberadas'),
}

export const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_TOKEN_TIME_END: (state, time) => {
        state.tokenTimeEnd = time
    },
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('auth.currentUser', newValue)
    },
    SET_CURRENT_ENTIDADE(state, newValue) {
        state.currentEntidade = newValue
        saveState('auth.currentEntidade', newValue)
    },
    SET_CURRENT_EMPRESA(state, newValue) {
        state.currenEmpresa = newValue
        saveState('auth.currentEmpresa', newValue)
    },
    SET_EMPRESAS(state, newValue) {
        state.empresasLiberadas = newValue
        saveState('auth.empresasLiberadas', newValue)
    },
    REMOVE_CURRENT_USER(state) {
        state.currentUser = {aut_hash: false, pes_nome: ''};
        removeState('auth.currentUser')
    },
    REMOVE_CURRENT_ENTIDADE(state) {
        state.currentEntidade = {ent_nome: ''};
        removeState('auth.currentEntidade')
    },
    REMOVE_CURRENT_EMPRESA(state) {
        state.currenEmpresa = {eco_codigo: '', eco_tributacao: ''};
        removeState('auth.currentEmpresa')
    },
    REMOVE_EMPRESAS(state) {
        state.empresasLiberadas = [];
        removeState('auth.empresasLiberadas')
    },
    SET_ENTCNPJ: (state, cnpj) => {
        state.entCNPJ = cnpj
    },
}

export const getters = {
    loggedIn(state) {
        if (!state.currentUser) {
            return false
        }
        return !(state.currentUser.aut_hash === false)
    },
    currentEmpresa(state) {
        return state.currenEmpresa;
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    logIn({commit}, user) {
        return new Promise((resolve, reject) => {
            login(user).then(response => {
                const {status, mensagem, dados} = response
                if (status) {
                    commit('SET_TOKEN', dados.token)
                    setToken(dados.token)
                    commit('SET_TOKEN_TIME_END', dados.expira)
                    setTimeEnd(dados.expira)
                    commit('SET_CURRENT_ENTIDADE', dados.entidade);
                    commit('SET_EMPRESAS', dados.empresas);
                    if (dados.empresas && dados.empresas.length === 1) {
                        let empresa = dados.empresas[0];
                        simplesNacionalAtualizaOptante(empresa.eco_codigo).then(response => {
                            const {status, mensagem, dados} = response
                            if (status) {
                                empresa.menu_simples = dados.menu_simples;
                                commit('SET_CURRENT_EMPRESA', empresa);
                                if (Object.prototype.hasOwnProperty.call(router.currentRoute.query, 'redirectFrom')) {
                                    router.go(router.currentRoute.query.redirectFrom)
                                } else {
                                    router.go(router.currentRoute)
                                }
                            } else {
                                reject(mensagem)
                            }
                        })
                    }
                    commit('SET_ENTCNPJ', dados.ent_cnpj)
                    setEntCnpj(dados.ent_cnpj)
                    commit('SET_CURRENT_USER', {
                        aut_hash: dados.aut_hash,
                        pes_nome: dados.pes_nome,
                        pes_cpfcnpj: dados.pes_cpfcnpj,
                        pes_mail: dados.pes_mail,
                        aut_access: dados.aut_access,
                        is_admin: (dados.aut_access === 'A')
                    })
                    if (Object.prototype.hasOwnProperty.call(router.currentRoute.query, 'redirectFrom')) {
                        router.push(router.currentRoute.query.redirectFrom)
                    } else {
                        router.push({name: 'painel'})
                    }
                } else {
                    reject(mensagem)
                }
            }).catch(error => {
                console.log(error)
                reject("Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.")
            }).finally(() => {
                resolve()
            })
        })
    },

    empresaAtual({commit}, empresa) {
        return new Promise((resolve, reject) => {
            simplesNacionalAtualizaOptante(empresa.eco_codigo).then(response => {
                const {status, mensagem, dados} = response
                if (status) {
                    empresa.menu_simples = dados.menu_simples;
                    commit('SET_CURRENT_EMPRESA', empresa);
                    if (Object.prototype.hasOwnProperty.call(empresa, 'redirectFrom')) {
                        router.push({ name: 'painel'});
                    } else {
                        if (Object.prototype.hasOwnProperty.call(router.currentRoute.query, 'redirectFrom')) {
                            router.go(router.currentRoute.query.redirectFrom)
                        } else {
                            router.go(router.currentRoute)
                        }
                    }
                } else {
                    reject(mensagem)
                }
            }).catch(error => {
                console.log(error)
                reject("Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.")
            }).finally(() => {
                resolve()
            })
        })
    },

    renovaToken({commit}) {
        return new Promise((resolve, reject) => {
            usuarioRenovaToken().then(response => {
                const {status, dados} = response
                if (status) {
                    commit('SET_TOKEN', dados.token)
                    setToken(dados.token)
                    commit('SET_TOKEN_TIME_END', dados.expira)
                    setTimeEnd(dados.expira)
                    resolve(true)
                } else {
                    reject(false)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    listEmpresa({commit}, empresas) {
        commit('SET_EMPRESAS', empresas);
    },

    empresa({commit}, empresa) {
        commit('SET_CURRENT_EMPRESA', empresa);
    },

    logOut({commit}) {
        return new Promise((resolve) => {
            commit('REMOVE_CURRENT_USER')
            commit('REMOVE_CURRENT_ENTIDADE')
            commit('REMOVE_EMPRESAS')
            commit('REMOVE_CURRENT_EMPRESA')
            removeToken()
            removeTimeEnd()
            removeEntCnpj()
            router.push('/' + '?redirectFrom=' + router.currentRoute.fullPath)
            resolve()
        })
    },
}


function getState(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
        return null;
    }
}

function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}

function removeState(key) {
    window.localStorage.removeItem(key)
}
